import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuantityPurchasedByDoctorComponent } from './quantity-purchased-by-doctor.component';

const routes: Routes = [
  {
    path:'**',
    component: QuantityPurchasedByDoctorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuantityPurchasedByDoctorRoutingModule { }
